[
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    -9
  ],
  [
    0,
    -6
  ],
  [
    0,
    -4
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    25,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    -36
  ],
  [
    0,
    -92
  ],
  [
    0,
    -44
  ],
  [
    0,
    -13
  ],
  [
    4,
    17
  ],
  [
    0,
    0
  ],
  [
    -6,
    -32
  ],
  [
    0,
    -55
  ],
  [
    0,
    -2
  ],
  [
    -6,
    0
  ],
  [
    0,
    0
  ],
  [
    -6,
    0
  ],
  [
    0,
    0
  ],
  [
    -3,
    0
  ],
  [
    0,
    0
  ],
  [
    -3,
    0
  ],
  [
    0,
    0
  ],
  [
    9,
    9
  ],
  [
    9,
    9
  ],
  [
    0,
    0
  ],
  [
    5,
    5
  ],
  [
    5,
    5
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    -7
  ],
  [
    0,
    -5
  ],
  [
    0,
    -5
  ],
  [
    0,
    -5
  ],
  [
    0,
    -2
  ],
  [
    0,
    -2
  ],
  [
    0,
    0
  ],
  [
    0,
    -7
  ],
  [
    0,
    -26
  ],
  [
    0,
    -5
  ],
  [
    0,
    -7
  ],
  [
    -7,
    -16
  ],
  [
    -2,
    -7
  ],
  [
    -17,
    -56
  ],
  [
    -12,
    -66
  ],
  [
    31,
    -2
  ],
  [
    0,
    -14
  ],
  [
    0,
    -9
  ],
  [
    -5,
    -17
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    -2,
    -9
  ],
  [
    -3,
    -75
  ],
  [
    0,
    -90
  ],
  [
    -17,
    -50
  ],
  [
    -60,
    -91
  ],
  [
    -2,
    -6
  ],
  [
    -4,
    -4
  ],
  [
    -19,
    -2
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    -32
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    -2,
    -2
  ],
  [
    -2,
    -2
  ],
  [
    -2,
    0
  ],
  [
    -2,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    -3
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    -2,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    -3,
    -2
  ],
  [
    -2,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    -2,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    -2,
    -19
  ],
  [
    0,
    0
  ],
  [
    0,
    -9
  ],
  [
    0,
    -3
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    13,
    -2
  ],
  [
    0,
    -5
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    -2,
    0
  ],
  [
    -2,
    -55
  ],
  [
    -2,
    -23
  ],
  [
    0,
    -61
  ],
  [
    0,
    -58
  ],
  [
    -7,
    -59
  ],
  [
    0,
    -56
  ],
  [
    0,
    -57
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    -4
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ],
  [
    0,
    0
  ]
]